import useFetch from "../../../hooks/useFetch";

export const useGetApiData = (
  api,
  stateName,
  setState,
  params = {},
  method = "get"
) => {
  const { loading, error } = useFetch(api, {
    method,
    params,
    onSuccess: (data) => setState(data),
  });
  return {
    loading,
    error,
  };
};
